import { ColumnModel, Attributes } from '@leverege/ui-attributes';

/* Initialize Constants */
const VALUE_TYPE = 'object';
const TYPE = `attr.column.${VALUE_TYPE}`;

/**
    * Gets name from data.
    */
function getName(data) {
  return Attributes.getDisplayName(data.attrName, data.objectType);
}

/* Initialize Model Base */
const base = {
  ...ColumnModel,
  getName
};
delete base.create;

/**
    * Creates an attribute detail model instance.
    */
function create(attrName, objectType) {
  return ColumnModel.create(TYPE, {
    attrName,
    objectType
  });
}

/* Export Modules */
export default {
  TYPE,
  create,
  ...base
};